<div *ngIf="!!productBlock" class="jb-max-width center mv6">
  <div class="pa0 jb-grid" role="list">
    <jb-product-block
      role="listitem"
      class="col-6-m col-4-l"
      *ngFor="let product of productBlock"
      jbSitemapNestedLinker
      [price]="product?.price"
      [target]="(product?.link)[0].newWindow"
      [href]="(product?.link)[0]?.href"
    >
      <jb-image
        *ngIf="product?.image"
        [cropped]="true"
        [alt]="(product?.image)[0]?.alt"
        [src]="(product?.image)[0]?.src | dynamicImageWidthPipe: 'image'"
        [height]="
          hasImageHeightWidthAttr && +(product?.image)[0]?.height > 0
            ? (product?.image)[0]?.height
            : null
        "
        [width]="
          hasImageHeightWidthAttr && +(product?.image)[0]?.width > 0
            ? (product?.image)[0]?.width
            : null
        "
        [placeholder]="
          (product?.image)[0]?.src
            | dynamicImageWidthPipe: 'placeholder':placeholderParams
        "
        [isLazy]="enableLazyLoadImage"
      >
      </jb-image>
      <jb-flag
        *ngIf="product?.offerRibbon"
        [title]="product?.offerRibbon"
      ></jb-flag>
      <ng-container JbTitle>{{ product?.title }}</ng-container>
      <ng-container JbDescription>
        {{ product?.content | truncate: '165' }}
      </ng-container>
      <ng-container JbProductDetail
        >{{ product?.description }} <br />{{ product?.from }}
      </ng-container>
      <jb-star-rating
        *ngIf="product?.rating"
        [rating]="product?.rating"
      ></jb-star-rating>
      <jb-dialog-link
        *ngIf="product?.restrictions"
        (click)="openLegalDialog($event, product?.restrictions)"
      >
        {{ (product?.restrictions)[0]?.legalLink }}
      </jb-dialog-link>
    </jb-product-block>
  </div>
</div>
